import { render, staticRenderFns } from "./center-wide.vue?vue&type=template&id=30c78dac"
import script from "./center-wide.vue?vue&type=script&lang=js"
export * from "./center-wide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports